export default "__VITE_ASSET__cBbuGF1i__"